module.exports = "<div class=\"blank\" fusePerfectScrollbar>\n\n    <fuse-bonresa [order]=\"order\" [transactions]=\"transactions\" [dueAmount]=\"dueAmount\"></fuse-bonresa>\n\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /usr/app/src/app/main/content/app/bonresapage/bonresapage.component.html
// module id = ../../../../../src/app/main/content/app/bonresapage/bonresapage.component.html
// module chunks = main